import apiClient from './apiClient';

export const workflowsAPI = {
  list: (params) => apiClient.get('/workflows/workflows/', { params }),
  get: (id) => apiClient.get(`/workflows/workflows/${id}/`),
  create: (data) => apiClient.post('/workflows/workflows/', data),
  update: (id, data) => apiClient.put(`/workflows/workflows/${id}/`, data),
  delete: (id) => apiClient.delete(`/workflows/workflows/${id}/`),

  listStages: (workflowId) => apiClient.get(`/workflows/stages/?workflow=${workflowId}`),
  getStage: (id) => apiClient.get(`/workflows/stages/${id}/`),
  createStage: (data) => apiClient.post('/workflows/stages/', data),
  updateStage: (id, data) => apiClient.put(`/workflows/stages/${id}/`, data),
  deleteStage: (id) => apiClient.delete(`/workflows/stages/${id}/`),

  listTransitions: (workflowId) => apiClient.get(`/workflows/transitions/?workflow=${workflowId}`),
  getTransition: (id) => apiClient.get(`/workflows/transitions/${id}/`),
  createTransition: (data) => apiClient.post('/workflows/transitions/', data),
  updateTransition: (id, data) => apiClient.put(`/workflows/transitions/${id}/`, data),
  deleteTransition: (id) => apiClient.delete(`/workflows/transitions/${id}/`),
};